import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import { ForgeInlineMessage } from '@tylertech/forge-react';

const TitleInlineMessage = ({ inlineMessage, isViewOnly,  withTabs}) => {
  
  const titleInlineMessageClassName = useMemo(() => {
    if (isViewOnly && withTabs) {
      return 'title-inline-message title-inline-message-isViewOnly-and-tabs';
    }
  
    if (isViewOnly || withTabs) {
      return 'title-inline-message title-inline-message-isViewOnly';
    }
  
    return 'title-inline-message';
  }, [isViewOnly, withTabs]);

  return (
    <ForgeInlineMessage slot="body-header" theme="info" className={titleInlineMessageClassName}>
      <p className="forge-typography--body2">{inlineMessage}</p>
    </ForgeInlineMessage>
  );
};

TitleInlineMessage.propTypes = {
  inlineMessage: PropTypes.string,
  isViewOnly: PropTypes.bool,
  withTabs: PropTypes.bool,
};

export default TitleInlineMessage;

